<template>
    <b-list-group class="list-group-accent" variant="dark">
        <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
            {{ $t('workspaces') }} <span><i class="fa fa-pencil" @click="() => $router.push('/admin/workspace')"></i></span>
        </b-list-group-item>
        <b-list-group-item href="#" :disabled="isCurrent(workspace)" :class="classes(workspace)" v-for="workspace in $store.getters.getCurrentProject.workspaces" v-bind:key="workspace.uuid" v-on:click="setWorkspace(workspace)">
            <div v-if="workspace !== undefined" >{{ workspace.name }}</div>
        </b-list-group-item>
    </b-list-group>
</template>

<style scoped lang="scss">
.fa-pencil {
    cursor: pointer
}

.fa-pencil:hover {
    color: #ccc;
}

.current {
    border-color: #ccc;
}
</style>

<script>
export default {
    name: 'Workspaces',
    methods: {
        setWorkspace(workspace) {
            this.$store.commit("SET_CURRENT_WORKSPACE", workspace)
            this.$emit('workspaceChange', workspace)
        },

        isCurrent(workspace) {
            return workspace.uuid == this.currentWorkspace.uuid
        },

        classes(workspace) {
            let classes = ''

            if (this.isCurrent(workspace)) {
                classes += 'current'
            }

            return classes
        }
    },

    computed: {
        currentWorkspace() {
            return this.$store.getters.getCurrentWorkspace
        }
    }
}
</script>